import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import './Testimonials.css';

const testimonialData = [
  { name: 'Kavita Mehta Thukral', role: 'Radiologist', review: 'Nachiketh Shetty is a dream coach to have.Very professional, highly intelligent and extremely patient, he suggests what is best for his mentee. His simplified, practical and no fuss approach makes the diet and fitness regime sustainable on a long term. He is always available to answer all your queries howsoever silly it maybe with utmost sincerity and thus making this transformation a lifelong process and not a short term goal. As I renew my 12 weeks to 24 weeks, I am really looking forward to the journey ahead. Thanks Nachiketh for being YOU' },
  {
    name: 'Soumya Rai',
    role: 'Home Maker',
    review: 'He is "The Best" and I mean it. Easily approachable, friendly, and has great understanding. I still have a question: "When do you sleep, Nachiketh???"'
  },
  {
    name: 'Swapnita Mahindrakar',
    role: 'Pilot',
    review: 'He not only helps with weight loss but also improves one\'s knowledge of nutrition. He was always available and kept track of my progress. He has amazing knowledge, and I can totally recommend him to anyone. He for sure knows his job.'
  },
  {
    name: 'Karmugi Mani',
    role: 'Housewife',
    review: 'Nachiketh is the best mentor I have ever seen. I am so happy that I chose him. He is very friendly, understanding, thoroughly knowledgeable, and available 24*7. His approach is logical and practical. I never felt like I was on a diet; it was just regular food, making it sustainable for the long term. He was also incredibly motivating whenever I felt low and made me realize that this isn\'t just a 12-week program but a lifelong journey toward a healthy lifestyle and quantified nutrition. Thank you so much, Nachiketh. I am looking forward to enrolling under you again in the near future.'
  },
  {
    name: 'Sonia Sehmi',
    review: 'I had minimal reference points when I hired Nachiketh as my mentor. However, throughout the journey under his mentorship, my appreciation of his training, diet, and workout methods only grew stronger. He is a thorough professional, from structured communication to tracking progress and providing guidance. His command over the subject is noteworthy, and he ensured we didn\'t just rush through the motions but instead made the journey both endurable and enjoyable while maintaining discipline and focus on the targets.'
  },
 
  {
    "name": "Bandesh Rao",
    "review": "Nachiketh in true sense understood me. I was initially feeling awkward to fill up the form sent by him (the questions were very weird with no right or wrong answer). However, I now realise that it was very important for him to understand my expectation and hence such a weird format. I am very happy with my progress over the last 12 weeks where my fat % has reduced by around 10%, keeping myself lean and healthy at the same time. He has always been easily approachable and is always ready to help on messages by suggesting alternate food options. I am now looking at renewing my stint with him in order to begin my next phase of transformation."
  },
  {
    "name": "Varsha",
    "role": "Event Management Company",
    "review": "It was the best decision that we made enrolling under Nachiketh sir. He has done the best for us and we are happy that we are continuing our journey under him for another 12 weeks. The progress is a bit slow because of our hectic schedule but that's okay. This time we are gonna be more serious about this fitness journey."
  },
  {
    "name": "Ashwini Gadipatil",
    "review": "Nachiketh is a wonderful coach and has very good knowledge; he is very patient to listen to trainees' queries. I would definitely recommend him. He understands your food habits and gives a plan accordingly. I have done many diet plans earlier but have given up in between. However, with Nachiketh's diet plan and workout, I never thought of giving up. He is very approachable and makes sure to give you a clear picture in the very beginning of the course. I am very happy with my transformation, completed 12 weeks, and looking forward to starting another 12 weeks journey. Thank you, Nachiketh."
  },
  {
    "name": "Shweta Poonja Shetty",
    "review": "Nachiketh has been an excellent mentor. He understood my goals right and guided me smoothly to awesome results. The best part was that the diet chart was so sustainable that I am able to continue with it even in my daily routine beyond 12 weeks of mentorship."
  },
  {
    "name": "Anuja Aiyappan",
    "role": "HR Professional",
    "review": "Knowledgeable, approachable, and immensely patient—these words aptly describe Nachiketh. He planned my charts, taking into consideration my daily routine and other constraints. As the diet given by him consisted of the usual daily food—including milk (he allowed my tea request), fruits, etc.—I was able to follow it with ease. Thank you, Nachiketh, for all your support and guidance!"
  },
  {
    "name": "Reva Rathore",
    "review": "I would like to take a moment to convey my gratitude and gratefulness to my coach, Mr. Nachiket Shetty, who helped me get rid of insulin injections within a stipulated time period of three months, from which I was suffering for the last two and a half years. I am really thankful to sir, who made the impossible POSSIBLE for me. I wish you all the luck for your future ventures."
  },
  {
    "name": "Dilip S",
    "review": "The journey has been very fruitful and challenging as well. It was not easy, but I was able to meet my target. I went from 88kg to 81kg. I believe I have enough knowledge now to maintain a healthy and fit life. I will always cherish and remember the guidance that I had at the beginning of my muscle gain/fat loss journey with you. Of course, I do want to stay in touch to share my progress and reach out if I have any doubts in the future. Thanks from the bottom of my heart. I give two thumbs up! If you are looking for someone with good knowledge and skills as a fitness mentor, look no further—Nachiketh is highly recommended."
  },
  {
    "name": "Pushpesh Kumar",
    "review": "More than anything else, he is one of the nicest people I have ever come across. He treats you as his friend and makes you feel comfortable so that you can ask even the silliest questions."
  },
  {
    "name": "Sneha Samarth",
    "review": "Excellent coach... Extremely courteous and encouraging. He kept me going through the 12 weeks and answered my questions and cleared my doubts without hesitation. He taught me that consistency is key and to make patience my best friend. Thank you!"
  }

];

const Testimonial = () => {
  return (
    <div className="testimonial-section">
      <div className="testimonial-stats">
        <h2 className="testimonial-heading">Testimonials</h2>
        <div className="stats-box">
          <h2>300+</h2>
          <p>Reviews on</p>
          <img src="https://res.cloudinary.com/ddkyeuhk8/image/upload/v1741854571/dt7yqgvl59loltv7mgrp.png" alt="Google" className="platform-logo" />
          <div className="rating">
            <div className="stars">★★★★★</div>
            <p>Rated 4.9</p>
          </div>
        </div>
      </div>

      <div className="testimonial-slider-container">
        <Swiper
          modules={[Navigation]}
          spaceBetween={30}
          slidesPerView={1}
          navigation
          breakpoints={{
            640: { slidesPerView: 1 },
            1024: { slidesPerView: 3 } // Desktop: 3 cards
          }}
          className="testimonial-slider"
        >
          {testimonialData.map((testimonial, index) => (
            <SwiperSlide key={index}>
              <div className="testimonial-card">
                <div className="testimonial-header">
                  <div className="user-info">
                    <h3>{testimonial.name}</h3>
                    <div className="rating">★★★★★</div>
                    <p className="role">{testimonial.role}</p>
                  </div>
                </div>
                <hr className="testimonial-divider" />
                <p className="testimonial-text">{testimonial.review}</p>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
};

export default Testimonial;
